import type { SVGProps } from "react";

export const Confluence = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="1em"
    preserveAspectRatio="xMidYMid"
    viewBox="0 -5 256 256"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Confluence</title>{" "}
    <defs>
      {" "}
      <linearGradient
        id="linearGradient-1"
        x1="99.140087%"
        x2="33.8589812%"
        y1="112.708084%"
        y2="37.7549606%"
      >
        {" "}
        <stop offset="18%" stopColor="#0052CC" />{" "}
        <stop offset="100%" stopColor="#2684FF" />{" "}
      </linearGradient>{" "}
      <linearGradient
        id="linearGradient-2"
        x1="0.92569163%"
        x2="66.1800713%"
        y1="-12.5823074%"
        y2="62.3057471%"
      >
        {" "}
        <stop offset="18%" stopColor="#0052CC" />{" "}
        <stop offset="100%" stopColor="#2684FF" />{" "}
      </linearGradient>{" "}
    </defs>{" "}
    <g>
      {" "}
      <path
        d="M9.26054484,187.329971 C6.61939782,191.637072 3.65318655,196.634935 1.13393863,200.616972 C-1.12098385,204.42751 0.0895487945,209.341911 3.85635171,211.669157 L56.6792921,244.175582 C58.5334859,245.320393 60.7697695,245.67257 62.8860683,245.153045 C65.0023672,244.633521 66.8213536,243.285826 67.9346417,241.412536 C70.0475593,237.877462 72.7699724,233.285929 75.7361837,228.369333 C96.6621947,193.831256 117.710105,198.057091 155.661356,216.179423 L208.037333,241.087471 C210.020997,242.031639 212.302415,242.132457 214.361632,241.366949 C216.420848,240.601441 218.082405,239.034833 218.967618,237.024168 L244.119464,180.137925 C245.896483,176.075046 244.088336,171.3377 240.056161,169.492071 C229.003977,164.291043 207.021507,153.92962 187.233221,144.380857 C116.044151,109.802148 55.5415672,112.036965 9.26054484,187.329971 Z"
        fill="url(#linearGradient-1)"
      />{" "}
      <path
        d="M246.11505,58.2319428 C248.756197,53.9248415 251.722408,48.9269787 254.241656,44.9449416 C256.496579,41.1344037 255.286046,36.2200025 251.519243,33.8927572 L198.696303,1.38633231 C196.82698,0.127283893 194.518741,-0.298915762 192.323058,0.209558312 C190.127374,0.718032386 188.241461,2.11550922 187.115889,4.06811236 C185.002971,7.60318607 182.280558,12.1947186 179.314347,17.1113153 C158.388336,51.6493918 137.340426,47.4235565 99.3891748,29.3012247 L47.1757299,4.5150757 C45.1920661,3.57090828 42.9106475,3.47008979 40.8514312,4.2355977 C38.7922149,5.00110562 37.1306578,6.56771434 36.2454445,8.57837881 L11.0935983,65.4646223 C9.31657942,69.5275012 11.1247267,74.2648471 15.1569014,76.1104765 C26.2090859,81.3115044 48.1915557,91.6729274 67.9798418,101.22169 C139.331444,135.759766 199.834028,133.443683 246.11505,58.2319428 Z"
        fill="url(#linearGradient-2)"
      />{" "}
    </g>
  </svg>
);

export default Confluence;
